"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailSubscriptionLinkDisplayName = exports.getEmailVariableLabel = exports.getEmailSystemHublVar = exports.getHublVariable = exports.hasHublVariable = exports.HUBL_VAR_REGEXP = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _iterables = require("../utils/iterables");

var _link = require("../constants/link");

var HUBL_VAR_REGEXP = /^{{\s*([a-zA-Z0-9_.]+)\s*}}$/;
exports.HUBL_VAR_REGEXP = HUBL_VAR_REGEXP;

var hasHublVariable = function hasHublVariable(str) {
  return /{{.*}}/.test(str);
};

exports.hasHublVariable = hasHublVariable;

var getHublVariable = function getHublVariable(str) {
  if (typeof str !== 'string') {
    return null;
  }

  var matches = str.trim().match(HUBL_VAR_REGEXP);
  return matches ? matches[1] : null;
};

exports.getHublVariable = getHublVariable;

var getEmailSystemHublVar = function getEmailSystemHublVar(str) {
  var hublVar = getHublVariable(str);

  for (var key in _link.EmailSubscriptionHublVariables) {
    if (hublVar === _link.EmailSubscriptionHublVariables[key]) {
      return hublVar;
    }
  }

  return null;
};

exports.getEmailSystemHublVar = getEmailSystemHublVar;

var getEmailVariableLabel = function getEmailVariableLabel(name) {
  var option = _link.EmailSubscriptionLinkOptions[name];
  return option ? _I18n.default.text((0, _link.i18nKey)(option.text)) : name;
};

exports.getEmailVariableLabel = getEmailVariableLabel;
var getEmailSubscriptionLinkDisplayName = (0, _iterables.compose)(getEmailVariableLabel, getEmailSystemHublVar);
exports.getEmailSubscriptionLinkDisplayName = getEmailSubscriptionLinkDisplayName;